import * as PageContainer from "../pages";
import {routesPaths} from "./routesPaths";

export function menuRoutes(appContextData) {
    const t = appContextData.i18n.t;
    let routes = [];

    if (t) {

        //1° LIVELLO MENU
        const wallet = {
            path: routesPaths.wallet,
            name: t("titleCase.menuWallet", {count: 1}),
            routes: []
        }

        const customer = {
            path: routesPaths.customerUsers,
            name: t("titleCase.menuCustomer", {count: 1}),
            component: PageContainer.CustomerUser,
            routes: [
                {
                    path: routesPaths.customerUsers,
                    name: t("titleCase.menuCustomerUsers", {count: 1}),
                    id: "customerUsers",
                    component: PageContainer.CustomerUser
                }
            ]
        }

        const paymentGateway ={
            path: routesPaths.paymentGateway,
            name: t("titleCase.menuPaymentGateway", {count: 1}),
            component: PageContainer.TransactionsDashboard,
            routes: [
                {
                    path: routesPaths.paymentGatewayTransactions,
                    name: t("titleCase.transactionList", {count: 1}),
                    id: "transactionList",
                    component: PageContainer.TransactionsDashboard
                }
            ]
        }

        const schedulePayment = {
            path: routesPaths.scheduledPayments,
            name: t("titleCase.menuScheduledPayments", {count: 1}),
            id: "scheduledPayments",
            component: PageContainer.ScheduledPayments
        }
        
        const statisticsPayment = {
            path: routesPaths.paymentGatewayStatistics,
            name: t("titleCase.menuStatistic", {count: 1}),
            id: "statistic",
            component: PageContainer.TransactionsStatistics
        }
     
        const paymentHub = {
            path: routesPaths.paymentHub,
            name: t("titleCase.menuTransactions", {count: 1}),
            component: PageContainer.PaymentHubStatistics,
            routes: [
                {
                    path: routesPaths.paymentHubStatistics,
                    name: t("titleCase.menuStatistic", {count: 1}),
                    id: "statistic",
                    component: PageContainer.PaymentHubStatistics
                },
            ]
        };

        const administration = {
            path: routesPaths.administration,
            name: t("titleCase.menuAdministration", {count: 1}),
            component: PageContainer.Config,
            routes: []
        }

        const billing = {
            path: routesPaths.billing,
            name: t("titleCase.menuBilling", {count: 1}),
            component: PageContainer.BillingProduct,
            routes: [
                {
                    path: routesPaths.billingProduct,
                    name: t("titleCase.menuBillingProduct", {count: 1}),
                    id: "billingProducts",
                    component: PageContainer.BillingProduct
                }
            ]
        };

        const emailSender = {
            path: routesPaths.emailDashboard,
            name: t("titleCase.menuEmail", {count: 1}),
            component: PageContainer.EmailSender,
            routes: [
                {
                    path: routesPaths.emailDashboard,
                    name: t("titleCase.menuEmailDashboard", {count: 1}),
                    id: "dashboard",
                    component: PageContainer.EmailSender
                },
                {
                    path: routesPaths.emailTemplate,
                    name: t("titleCase.menuEmailTemplate", {count: 1}),
                    id: "template",
                    component: PageContainer.EmailTemplate
                }
            ]
        };

        //2° LIVELLO MENU
        const voucher = {
            path: routesPaths.walletVouchersCampaign,
            name: t("titleCase.menuWalletVouchers", {count: 1}),
            id: "voucher",
            sub: [
                {
                    path: routesPaths.walletVouchersCampaign,
                    name: t("titleCase.menuWalletVouchersCampaign", {count: 1}),
                    id: "wVouchersCampaign",
                    component: PageContainer.WalletVouchersCampaign
                },
                {
                    path: routesPaths.walletVouchers,
                    name: t("titleCase.menuWalletVouchersList", {count: 1}),
                    id: "wVouchers",
                    component: PageContainer.WalletVouchers
                }
            ]
        }
        const sdd ={
            path: routesPaths.bulkSdd,
            name: t("titleCase.debit", {count: 1}),
            id: "sdd",
            component: PageContainer.Bulk,
            sub: [ // Qui stiamo aggiungendo un sottomenu
                {
                    path: routesPaths.bulkSdd_sub,
                    name: t("titleCase.bulksdd", {count: 1}),
                    id: "bulk",
                    component: PageContainer.Bulk
                },
                {
                    path: routesPaths.debitSdd,
                    name: t("titleCase.debit", {count: 1}),
                    id: "debit",
                    component: PageContainer.DebitSdd
                },
                {
                    path: routesPaths.downloadSdd,
                    name: t("titleCase.file", {count: 1}),
                    id: "fileSdd",
                    component: PageContainer.DownloadSdd
                }
            ]
        };

        const sct = {
            path: routesPaths.bulkSct,
            name: t("titleCase.menuSctSearch", {count: 1}),
            id: "sct",
            component: PageContainer.BulkSCT,
            sub: [ // Qui stiamo aggiungendo un sottomenu
                {
                    path: routesPaths.bulkSct_sub,
                    name: t("titleCase.bulksct", {count: 1}),
                    id: "bulk",
                    component: PageContainer.BulkSCT
                },
                {
                    path: routesPaths.sct,
                    name: t("titleCase.menuSctSearch", {count: 1}),
                    id: "credit",
                    component: PageContainer.Sct
                },
                {
                    path: routesPaths.downloadSct,
                    name: t("titleCase.file", {count: 1}),
                    id: "fileSct",
                    component: PageContainer.DownloadSct
                }
            ]
        };

        const mandate = {
            path: routesPaths.mandate,
            name: t("titleCase.menuMandateSearch", {count: 1}),
            id: "mandate",
            component: PageContainer.Mandate,
            sub: [ // Qui stiamo aggiungendo un sottomenu
                {
                    path: routesPaths.mandateList,
                    name: t("titleCase.menuMandateSearch", {count: 1}),
                    id: "list",
                    component: PageContainer.Mandate
                }
            ]
        };

        const crossborder = {
            path: routesPaths.crossborder,
            name: t("titleCase.menuInsertCrossBorder", {count: 1}),
            id: "crossborder",
            component: PageContainer.CrossBorder
        };

        const paymentPage = {
            path: routesPaths.uploadPayment,
            name: t("titleCase.menuTransactionsPayment", {count: 1}),
            id: "uploadTrx",
            component: PageContainer.UploadPaymentContainer
        }
        
        const creditPage = {
            path: routesPaths.uploadCredit,
            name: t("titleCase.menuTransactionsCredit", {count: 1}),
            id: "uploadCredit",
            component: PageContainer.UploadCreditContainer
        };

        const vopcheck = {
            path: routesPaths.VoPcheck,
            name: t("titleCase.VoPcheck", {count: 1}),
            id: "VoPcheck",
            component: PageContainer.VoPcheck 
        };

        const users = {
            path: routesPaths.usersDashboard,
            name: t("titleCase.menuUsers", {count: 1}),
            id: "userSubMenu",
            sub: [
                {
                    path: routesPaths.usersDashboard,
                    name: t("titleCase.menuUsersManagement", {count: 1}),
                    id: "cUsers",
                    component: PageContainer.AdminUsersDashboard
                }
                ,
                {
                    path: routesPaths.createUser,
                    name: t("titleCase.menuUsersAdd", {count: 1}),
                    id: "addUser",
                    component: PageContainer.AdminUserCreate
                }
            ]
        };

        const reconciliation = {
            path: routesPaths.reconciliationSearch,
            name: t("titleCase.menuReconciliation", {count: 1}),
            component: PageContainer.ReconciliationSearch,
            routes: [
                {
                    path: routesPaths.reconciliationSearch,
                    name: t("titleCase.menuReconciliationDashboard", {count: 1}),
                    id: "dashboard",
                    component: PageContainer.ReconciliationSearch
                },
                {
                    path: routesPaths.reconciliationFile,
                    name: t("titleCase.menuReconciliationFile", {count: 1}),
                    id: "file",
                    component: PageContainer.ReconciliationFile
                },
                {
                    path: routesPaths.reconciliationFailDay,
                    name: t("titleCase.menuReconciliationFailDay", {count: 1}),
                    id: "failday",
                    component: PageContainer.ReconciliationFailDay
                }
            ]
        };

        const config = {
            path: routesPaths.config,
            name: t("titleCase.config", {count: 1}),
            component: PageContainer.Config
        };

        const commission = {
                    path: routesPaths.commissionsDashboard,
                    name: t("titleCase.menuCommissions", {count: 1}),
                    component: PageContainer.CommissionsDashboard,
                    routes: [
                        {
                            path: routesPaths.commissionsDashboard,
                            name: t("titleCase.menuCommissionsManagement", {count: 1}),
                            id: "dashboard",
                            component: PageContainer.CommissionsDashboard
                        },
                        {
                            path: routesPaths.commissionsProductsDashboard,
                            name: t("titleCase.menuCommissionsProductsManagement", {count: 1}),
                            id: "product",
                            component: PageContainer.CommissionsProductsDashboard
                        }
                    ]
                };

        const reports = {
            path: routesPaths.reports,
            name: t("titleCase.menuReports", {count: 1}),
            component: PageContainer.ReportsDashboard,
            routes: [
                {
                    path: routesPaths.reportsConfigurations,
                    name: t("titleCase.menuReportsConfigurations", {count: 1}),
                    id: "reportsConfigurations",
                    component: PageContainer.ReportsDashboard
                }
            ]
        };

        if(appContextData.enabledModules.includes("CUSTOMER")){
            routes.push(customer);     
        }

        if(appContextData.enabledModules.includes("WALLET")){
            wallet.routes.push(voucher);

            routes.push(wallet);
        }
        if(appContextData.enabledModules.includes("STATISTICS")){
            paymentGateway.routes.push(statisticsPayment);
        }

        if(appContextData.enabledModules.includes("PAY") || appContextData.enabledModules.includes("CREDIT")){
            if(appContextData.enabledModules.includes("PAY")){
                paymentGateway.routes.push(paymentPage);
            }

            if(appContextData.enabledModules.includes("CREDIT")){
                paymentGateway.routes.push(creditPage);
            }

            routes.push(paymentGateway);
        }
        if(appContextData.enabledModules.includes("INSTALLMENT")){
            paymentGateway.routes.push(schedulePayment);
        }


        if(appContextData.enabledModules.includes("RECONCILIATION")){
            routes.push(reconciliation);
        }

        if (appContextData.enabledModules.includes("VOPCHECK") || appContextData.enabledModules.includes("SDD") || appContextData.enabledModules.includes("SCT") || appContextData.enabledModules.includes("MANDATE")) {
            
            if(appContextData.enabledModules.includes("SCT")){
                paymentHub.routes.push(sct);
            }
        
            if(appContextData.enabledModules.includes("SDD")){
                paymentHub.routes.push(sdd);
            }
            
            if(appContextData.enabledModules.includes("SCTCB")){
                paymentHub.routes.push(crossborder);
            }

            if(appContextData.enabledModules.includes("MANDATE")){
                paymentHub.routes.push(mandate);
            }

            if(appContextData.enabledModules.includes("VOPCHECK")){
                paymentHub.routes.push(vopcheck);     
            }

            routes.push(paymentHub);
        }
        
        if(appContextData.enabledModules.includes("BILLING")){
            routes.push(billing);
        }

        if(appContextData.enabledModules.includes("CONFIG") || appContextData.enabledModules.includes("USER")){
            if(appContextData.enabledModules.includes("CONFIG")){
                administration.routes.push(config);
            }
            if(appContextData.enabledModules.includes("USER")){
                administration.routes.push(users);
            }
            routes.push(administration);
        }

        if(appContextData.enabledModules.includes("COMMISSIONS")){
            routes.push(commission);
        }

        if(appContextData.enabledModules.includes("REPORT")){
            routes.push(reports);
        }


        const routesOrder = [customer.name,paymentGateway.name,billing.name,emailSender.name,reconciliation.name,paymentHub.name,commission.name,reports.name,wallet.name,administration.name];

        let newRoutes = routesOrder.map(el => routes.find(element => element.name === el) || {});
        routes = newRoutes.filter(value => Object.keys(value).length !== 0);
    }

    return routes;
}
